import { inject, provide, ref, type InjectionKey, type Ref } from 'vue';
import type { FileSystemItem } from '../../types';

/**
 * The two pieces of state a drag itself carries — everything else a drop used to need
 * (transferringPaths, pendingTransfer, the mutations) has moved to
 * logic/transfer/useFileManagerTransfer.ts, since neither ref is read anywhere inside runTransfer/
 * requestTransfer: useDropTarget's onDrop already snapshots draggedItems into the transfer intent
 * before handing it off.
 */
export type FileManagerDragState = {
  draggedItems: Ref<FileSystemItem[]>;
  dragOverPath: Ref<string | null>;
};

export const fileManagerDragKey: InjectionKey<FileManagerDragState> =
  Symbol('fileManagerDrag');

export const provideFileManagerDrag = () => {
  const state: FileManagerDragState = {
    draggedItems: ref<FileSystemItem[]>([]),
    dragOverPath: ref<string | null>(null),
  };
  provide(fileManagerDragKey, state);
  return state;
};

export const useFileManagerDrag = () => {
  const state = inject(fileManagerDragKey);
  if (!state) {
    throw new Error(
      'useFileManagerDrag() must be called within a component tree provided by provideFileManagerDrag()',
    );
  }
  return state;
};
